





























































































import {Component, Vue, Watch, Prop} from 'vue-property-decorator';
import {Getter, Action} from "vuex-class";
import {FormRowWings, SelectWings} from 'wings-ui-components';
import PushFilter from '@/components/Distributions/PushFilter.vue';
import SaveTemplate from '@/components/Templates/SaveTemplate.vue';
import { notifyError } from '@/utils/notify-helper';

@Component({components: {FormRowWings, SelectWings, PushFilter, SaveTemplate}})
export default class PushFilters extends Vue {
  @Prop() distribution!: any;
  @Prop() applicationId!: number;

  @Getter("pushOS") pushOSList: any;
  // @Getter("pushOSVersions") pushOSVersionsList: any;
  @Getter("pushSDKVersions") pushSDKVersionsList: any;
  // @Getter("pushMappVersions") pushMappVersionsList: any;
  @Getter("pushFilters") pushFilterList: any;
  @Getter("applicationAttributes") applicationAttributesList: any;

  @Action("getPushOS") actionGetPushOS: any;
  @Action("getPushOSVersions") actionGetPushOSVersions: any;
  @Action("getPushSDKVersions") actionGetPushSDKVersions: any;
  @Action("getPushMappVersions") actionGetPushMappVersions: any;
  @Action("getPushFilters") actionGetPushFilters: any;
  @Action("savePushFilter") actionSavePushFilter: any;

  private filterId: any = null
  private isShowSaveTemplate = false
  private canSave = false

  pushOSVersionsList = []
  pushMappVersionsList = []

  async created() {
    try {
      this.actionGetPushOS()
      this.actionGetPushSDKVersions()
      this.actionGetPushFilters()
      const resp = await this.actionGetPushMappVersions({app_id: this.applicationId})
      this.pushMappVersionsList = resp.data.length > 0 ? resp.data[0].versions : []
    } catch(error) {
      notifyError(error);
    }
  }

  getState() {
    return {
      filterId: this.filterId,
      os_ids: this.distribution.os_ids,
      os_version_ids: this.distribution.os_version_ids,
      sdk_ids: this.distribution.sdk_ids,
      mapp_ids: this.distribution.mapp_ids,
      client_filter: this.distribution.client_filter,
      device_filter: this.distribution.device_filter,
    }
  }

  setState(state: any = null) {
    if (state) {
      // if (state?.filterId) this.filterId = state.filterId
      if (state?.os_ids) this.distribution.os_ids = state.os_ids
      if (state?.os_version_ids) this.distribution.os_version_ids = state.os_version_ids
      if (state?.sdk_ids) this.distribution.sdk_ids = state.sdk_ids
      if (state?.mapp_ids) this.distribution.mapp_ids = state.mapp_ids
      if (state?.client_filter) this.distribution.client_filter = state.client_filter
      if (state?.device_filter) this.distribution.device_filter = state.device_filter
    } else {
      this.filterId = null
      this.distribution.os_ids = ''
      this.distribution.os_version_ids = []
      this.distribution.sdk_ids = []
      this.distribution.mapp_ids = []
      this.distribution.client_filter = null
      this.distribution.device_filter = null
    }
  }

  async saveFilter(name: string) {
    try {
      await this.actionSavePushFilter({
        name: name,
        client_filter: this.distribution.client_filter,
        device_filter: this.distribution.device_filter,
      })
      await this.actionGetPushFilters()
      const filter = this.pushFilterList.find((item: any) => item.Name == name)
      this.filterId = filter?.FilterId
      this.canSave = false
    } catch(error) {
      notifyError(error);
    }
  }

  get clientAttributesList() {
    return this.applicationAttributesList.filter((item: any) => item.AttributeOwner.toLowerCase() == 'client')
  }

  get deviceAttributesList() {
    return this.applicationAttributesList.filter((item: any) => item.AttributeOwner.toLowerCase() == 'device')
  }

  get currentFilter() {
    return this.pushFilterList.find((item: any) => item.FilterId == this.filterId)
  }

  onClientFilterChange(filter: string) {
    this.distribution.client_filter = filter
    this.checkCanSave()
  }

  onDeviceFilterChange(filter: string) {
    this.distribution.device_filter = filter
    this.checkCanSave()
  }

  checkCanSave() {
    this.canSave = (this.currentFilter?.Client_Filter != this.distribution.client_filter
                    || this.currentFilter?.Device_Filter != this.distribution.device_filter) ? true : false
    if (!this.distribution.client_filter && !this.distribution.device_filter) this.canSave = false
  }

  @Watch('filterId', {immediate: true})
  onChangeStartDateTime(val: string, oldVal?: string) {
    if (val) {
      this.distribution.client_filter = this.currentFilter?.Client_Filter
      this.distribution.device_filter = this.currentFilter?.Device_Filter
    }
    if (oldVal && !val) {
      this.distribution.client_filter = undefined
      this.distribution.device_filter = undefined
    }
  }

  @Watch('distribution.os_ids', {immediate: true})
  async onChangeOS(val: string, oldVal?: string) {
    if (val) {
      const resp = await this.actionGetPushOSVersions({os_filter: val})
      this.pushOSVersionsList = resp.data.length > 0 ? resp.data[0].versions : []
    } else {
      this.pushOSVersionsList = []
    }
    if ((val && oldVal) || (oldVal && !val)) this.distribution.os_version_ids = []
  }

}
